<template>
  <div class="project_notice_w bc_fff">
    <el-tabs v-if="cmsNode" v-model="childCode">
      <el-tab-pane
        v-for="tab in cmsNode.nodeData"
        :key="tab.nodeInfoVo.code"
        :label="tab.nodeInfoVo.name"
        :name="tab.nodeInfoVo.code"
      >
        <div
          v-if="!nodeChildArticles || !nodeChildArticles.length"
          style="height: 100%"
          class="x_y_center"
        >
          <img src="@/assets/images/empty_icon.png" alt="" />
          <span style="margin: 0 0 0 10px" class="fz14">暂无数据</span>
        </div>

        <div
          class="div_1 fz14 c_1A1A1A d_flex justify_content_sb"
          v-for="item in nodeChildArticles"
          v-else
          @click="onLinkClick(tab, item)"
          :key="item.id"
        >
          <span class="span_1 text_ellipsis">{{ item.title }}</span>
          <span class="c_808080">{{
            formatDate(new Date(tranTimeFormat(item.createdAt)), "yyyy-MM-dd")
          }}</span>
        </div>
      </el-tab-pane>
    </el-tabs>

    <router-link
      v-if="cmsNodeChlid"
      :to="`${cmsNodeChlid.nodeInfoVo.nodeModel.route}/${cmsNodeChlid.nodeInfoVo.id}`"
      class="more_w fz12 c_1A1A1A"
    >
      <span class="span_2">更多</span>&nbsp;&nbsp;>>
    </router-link>
  </div>
</template>

<script>
import { cms_article_list } from "@/api/portal";
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import { formatDate } from "@/utils";
export default {
  props: {
    cmsNodeCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      childCode: "", // 子栏目code
      nodeChildArticles: [], // 栏目数据列表

      cmsNode: null,
      cmsNodeChlid: null,
    };
  },
  computed: {
    ...mapGetters(["siteInfo", "nodeSubsets"]),
    formatDate() {
      return function (date, fmt) {
        return formatDate(date, fmt);
      };
    },

    tranTimeFormat() {
      return function (dateStr) {
        return dateStr.replace(/-/g, "/");
      };
    },
  },
  watch: {
    childCode(n, o) {
      this.cmsNodeChlid = this.cmsNode.nodeData.find(
        (i) => i.nodeInfoVo.code === n
      );
      o && this.getArticleData();
    },
    nodeSubsets:{
      handler(n){
        if(n.length){
          this.init();
        }
      },
      immediate:true
    }
  },
  created() {

  },
  methods: {
    // 初始化
    init() {
      this.cmsNode = this.nodeSubsets.find((i) => i.code === this.cmsNodeCode);
      this.cmsNodeChlid = this.cmsNode.nodeData[0];
      this.childCode = this.cmsNodeChlid.nodeInfoVo.code;
      this.nodeChildArticles = this.cmsNodeChlid.articles;
    },

    // 获取某一栏目文章数据 api
    async getArticleData(code) {
      const { data } = await cms_article_list({
        code: this.childCode,
        rows: 8,
      });
      this.nodeChildArticles = data.list;
    },
    // 链接点击
    onLinkClick(tab, item) {
      Cookies.set("cmsNodeId", this.cmsNode.id);
      Cookies.set("cmsNodeChlidId", tab.nodeInfoVo.id);
      this.$router.push(`${tab.nodeInfoVo.infoModel.route}/${item.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.project_notice_w {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 282px;
  border: 1px solid #e6e6e6;
  .div_1 {
    padding: 15px 0;
    border-bottom: 1px solid #e6e6e6;

    .span_1 {
      display: inline-block;
      max-width: 400px;
    }
    &:hover {
      cursor: pointer;
      .span_1 {
        text-decoration: underline;
      }
    }
    &:last-child {
      border: none;
    }
  }

  .more_w {
    position: absolute;
    right: 21px;
    top: 13px;
  }
  .span_2 {
    &:hover {
      text-decoration: underline;
    }
  }

  ::v-deep .el-tabs__header {
    margin: 0;
  }
}
.project_notice_w ::v-deep .el-tab-pane {
  margin-top: 5px;
}
.project_notice_w ::v-deep .el-tabs__content {
  overflow: hidden;
  height: 238px;
  padding: 0 26px;
  box-sizing: border-box;
}
.project_notice_w ::v-deep .el-tabs__item {
  height: 44px;
  font-size: 18px;
  padding: 0 24px;
}
.project_notice_w ::v-deep .el-tabs__nav {
  .is-active {
    font-weight: bold;
    color: #1a1a1a;
  }
}
.project_notice_w ::v-deep .el-tabs__item:hover {
  color: #1a1a1a !important;
}

.project_notice_w ::v-deep .el-tabs__active-bar {
  background-color: #0983cc;
}
.project_notice_w ::v-deep .el-tabs__nav {
  transform: translateX(26px) !important;
}
</style>
